import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { loginPostApi } from "../../queries";
import { AuthLocalInput, ILogin } from "../../../types";

export function useLoginMutation() {
  return useMutation<AxiosResponse<ILogin>, AxiosError, AuthLocalInput>({
    mutationFn: ({ email, password }) => loginPostApi(email, password),
  });
}
